import { FaSpinner } from "react-icons/fa";

function LoadingSmall() {
  return (
    <FaSpinner className="animate-spin" />
  );
}
export default LoadingSmall;
